import { useContext, useState } from 'react'
import { Button, Modal, Spinner } from 'react-bootstrap'
import { AppContext } from '../context/AppContext'
import fetchData from '../utils/fetchData'
import getCookie from '../utils/getCookie'

const DeleteUser = ({ isModal, setModal, id, setId, getUsers }) => {
  // ! context
  const { setAlert } = useContext(AppContext)

  // ! hooks
  const [isSubmitting, setSubmitting] = useState(false)

  // ! delete specific user
  const handleDelete = async (e) => {
    e.preventDefault()
    setSubmitting(true)
    try {
      const { data } = await fetchData.delete(`/user/${id}`, {
        headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` },
      })
      getUsers()
      setSubmitting(false)
      setAlert({
        show: true,
        variant: 'success',
        message: 'User successfully deleted',
        icon: 'mdi mdi-checked',
        duration: 5,
      })
      hideModal()
    } catch (error) {
      setSubmitting(false)
      console.log({ ...error }, error)
      setAlert({
        show: true,
        variant: 'danger',
        message:
          error?.response?.data?.message ||
          'Something went wrong. Please try again.',
        icon: 'mdi mdi-close',
        duration: 5,
      })
    }
  }

  // ! hide modal
  const hideModal = () => {
    setModal(false)
    setId()
  }

  return (
    <Modal show={isModal} size='sm' centered onHide={hideModal}>
      <Modal.Header closeButton>
        <Modal.Title>Are You Sure</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Once you delete a user you will never recovery it again.
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleDelete} disabled={isSubmitting}>
          Delete{' '}
          {isSubmitting && (
            <Spinner animation='border' size='sm' className='ms-2' />
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteUser
